<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="delete-dialog"
    v-bind:id="whichComponent"
  >
    <v-card>
      <v-card-title>
        <h3>Delete {{ whichComponent }}</h3>
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to delete the {{ whichComponent }}?</p>
        <p>This action cannot be undone.</p>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Cancel</v-btn>

        <v-btn color="error darken-1" @click="confirmDialog" :disabled="loading">
          <v-icon left v-if="!loading">fas fa-trash</v-icon>
          <v-icon left v-else>fas fa-spinner fa-spin</v-icon>
          Delete {{ whichComponent }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      component: "Environment",
      loading: false
    };
  },
  props: ["showDeleteDialog", "isSnapshot"],
  watch: {
    showDeleteDialog() {
      this.loading = false;
    }
  },
  computed: {
    whichComponent() {
      return this.isSnapshot ? "Snapshot" : "Environment";
    },
    showDialog: {
      get() {
        return this.showDeleteDialog;
      },
      set(value) {
        this.$emit('update:showDeleteDialog', value)
      } 
    }
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.loading = true;
      this.$emit("confirmDeleteDialog");
    }
  }
};
</script>

<style scoped>
.delete-dialog h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.delete-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.delete-dialog p {
  font-weight: 500;
}

.delete-dialog p:nth-child(2) {
  margin-top: -15px;
}

.delete-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}
</style>